import { Button, ButtonProps } from "@mui/material";
import { useAppSelector } from "../../../../app/hooks";
import { AccessRightChecks } from "../../../../features/user/accessRightChecks";

interface CustomButtonProps extends ButtonProps {
  accessRightChecks?: AccessRightChecks;
}

export const CustomButton = ({
  accessRightChecks,
  ...rest
}: CustomButtonProps) => {
  const user = useAppSelector((state) => state.user.user);

  const hasAccess =
    user &&
    accessRightChecks?.every((check) =>
      typeof check === "function" ? check(user) : !!check,
    );

  // If access right check is not provided, the button is always visible
  // If the check is provided and user doesn't fulfill it, don't display the button
  return accessRightChecks === undefined || hasAccess ? (
    <Button
      {...rest}
      onClick={(event) => {
        event.currentTarget.blur();
        rest.onClick && rest.onClick(event);
      }}
    />
  ) : null;
};
